export { default } from './IconPromo';
